<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/blogs",
		    "name": "Blogs"
		  }
		},{
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": "https://www.protectt.ai/mobile-payments-application-security-controls",
              "name": "Mobile Payments Application Security Controls: RBI Guidelines You Must Know"
            }
          }		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a>
                        >
                        <a routerLink="/blogs">Blogs</a>
                        >
                        Mobile Payments Application Security Controls: RBI Guidelines You Must Know
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block">
    <div class="container subbanner" (window:resize)="onResize($event)">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading"> </h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!--// Breadcrumb -->


<script type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "Article",
      "name": "Mobile Payments Application Security Controls: RBI Guidelines You Must Know",
      "description": "With the increase in mobile app users & transactions and the corresponding increase in mobile app-related cyber threats, the requirement for minimum security" 
       } 
    </script>


<!-- Page Conttent -->
<main class="page-content">

    <!-- content-wraper start -->
    <div class="content-wraper section-pb section">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 order-2 order-lg-2">
                    <!-- blog-widget-wrap start -->
                    <app-blog-sidebar></app-blog-sidebar>
                    <!-- blog-widget-wrap end -->
                </div>

                <div class="col-lg-9 order-1 order-lg-1">
                    <!-- blog-details-wrapper start -->
                    <div class="blog-details-wrapper mt-30">
                        <!-- <div class="blog-details-image">
                            <img src="assets/images/blog/blog-details.webp" alt="blog-details">
                        </div> -->
                        <div class="postinfo-wrapper">
                            <div class="post-info">

                                <h3>Mobile Payments Application Security Controls: RBI Guidelines You Must Know</h3>
                                <img src="../../../assets/images/blog/mobile-payments-application-security-control.png"
                                    alt="Enhance your Android Phone Security" class="mt-3 og_image_url">
                                <p class="mt-30px">
                                    With the increase in mobile app users & transactions and the corresponding increase
                                    in mobile app-related
                                    cyber threats, the requirement for minimum security control standards is the need of
                                    the hour to ensure
                                    the safety & security of users’ data and funds.
                                </p>
                                <p>The Reserve Bank of India (RBI) has published guidelines to boost India’s digital
                                    payments through
                                    enhanced security. Mobile payment application security controls have been mentioned
                                    prominently in the
                                    RBI master circular on the subject. Regulated Entities (RE) like commercial banks,
                                    payments banks, small
                                    finance banks, and credit card issuing NBFCs are advised to strengthen their mobile
                                    application payment
                                    ecosystem. Here are the key pointers from RBI that an RE must know:</p>
                                <!-- <ol type="I"> -->
                                <p>I. On detection of any anomalies or exceptions for which the mobile application was
                                    not
                                    programmed, the customer shall be directed to remove the current copy/ instance of
                                    the
                                    application and proceed with the installation of a new copy/ instance of the
                                    application. REs shall
                                    be able to verify the version of the mobile application before the transactions are
                                    enabled.</p>
                                <p>II. Validation of the security and compatibility condition of the device/ operating
                                    system and the mobile application.</p>
                                <p>III. Implement a code that checks if the device is rooted/jailbroken prior to the
                                    installation of the mobile application and disallows the mobile application to
                                    install / function if the phone is rooted/ jailbroken.</p>
                                <p>IV. Checksum of the currently active version of the application shall be hosted on a
                                    public platform so that users can verify the same.</p>
                                <p>V. REs shall ensure device binding of the mobile application.</p>
                                <p>VI. For the additional factor of authentication, REs may consider implementing
                                    alternatives to SMS-based OTP authentication mechanisms.</p>
                                <p>VII. Applications must be able to identify non-usage beyond a specified period, new
                                    network connections, or connections from unsecured networks like unsecured Wi-Fi
                                    connections and must implement appropriate authentication/ checks/ measures to
                                    perform transactions under those circumstances.</p>
                                <p>VIII. The mobile application should not store/ retain sensitive personal/ consumer
                                    authentication information such as user IDs, passwords, keys, hashes, and hard-coded
                                    references on the device.</p>
                                <p>IX. Native encryption & decryption of local data storage (e.g., in temp files).</p>
                                <p>X. Design anti-malware capabilities into mobile apps.</p>
                                <p>XI. Mobile applications should be secured from SQL injection type of vulnerabilities.
                                </p>
                                <p>XII. REs shall conduct security testing, including review of source code,
                                    Vulnerability Assessment (VA), and Penetration Testing (PT) of their digital payment
                                    applications to assure that the application is secure for putting through
                                    transactions while preserving confidentiality and integrity of the data that is
                                    stored and transmitted.</p>
                                <p>XIII. Secure download/install of the mobile app after baseline requirements are met.
                                </p>
                                <p>XIV. Deactivate older versions of the application in a phased but timely manner.
                                    Maintain a single version of the mobile apps, excluding the overlap period while
                                    phasing out the older version.</p>
                                <p>XV. Application sandbox/containerization.</p>
                                <p>XVI. Mobile app to have the ability to identify remote access applications (to the
                                    extent possible) and prohibit remote login access to the mobile app.</p>

                                <!-- </ol> -->
                                <div>
                                    <h3>How AppProtectt helps?</h3>
                                    <p>
                                        <a style="color:#da2b27" routerLink="/appprotectt">AppProtectt</a>, by
                                        Protectt.ai, is the ideal state-of-the-art <a style="color:#da2b27" routerLink="/rasp">RASP solution</a> that provides
                                        end-to-end protection.
                                        The security solution assists the REs in handling with finesse the Mobile
                                        Payment Application Security Control aspect of the RBI’s master circular.
                                    </p>
                                    <p>
                                        Powered by Artificial Intelligence (AI) and Machine Learning (ML), AppProtectt is the
                                        ultimate solution to protect and safeguard the payment or banking application
                                        from malicious cyber-attacks and unwanted intrusions.
                                    </p>
                                    <p>
                                        AppProtectt ensures quick
                                        implementation and reduces TCO. AppProtectt by Protectt.ai injects
                                        comprehensive, 360-degree security with 40+ cyber security features that enable
                                        <a style="color:#da2b27" routerLink="/rasp">Runtime Application Self
                                            Protection</a> (RASP) for advanced detection and mitigation of all types of
                                        mobile threats - from app tampering to being reverse engineered. We help your
                                        organization offload security concerns enabling you to focus on developing your
                                        main business logic.
                                    </p>
                                    <p class="blogquote">As written by Sunita Handa - Principal Advisor, Protectt.ai</p>
                                </div>
                            </div>
                        </div>
                        <!-- blog-details-wrapper end -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- content-wraper end -->

</main>